import { CustomPivotTabIdSeparator, PendingCustomPivotId, } from '../models/Constants';
import { CustomFilterType } from '../models/Filters';
export function getCustomPivotFromTabId(tabId, tagMap) {
    if (!tabId) {
        return undefined;
    }
    if (tabId === PendingCustomPivotId) {
        return {
            customFilterType: CustomFilterType.Pending,
            customFilterKey: '',
        };
    }
    else {
        var separatorIndex = tabId.indexOf(CustomPivotTabIdSeparator);
        if (separatorIndex > 0) {
            var filterTypeString = tabId.substring(0, separatorIndex);
            var customFilterType = CustomFilterType[filterTypeString];
            if (customFilterType) {
                var customFilterKey = tabId.substring(separatorIndex + 1);
                var customPivot = {
                    customFilterType: customFilterType,
                    customFilterKey: customFilterKey,
                };
                if (customFilterType === CustomFilterType.Tagv2) {
                    if (!tagMap || !tagMap.has(customFilterKey)) {
                        return undefined;
                    }
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    customPivot.customFilterTitle =
                        tagMap.get(customFilterKey)[0].value;
                }
                return customPivot;
            }
        }
    }
    return undefined;
}
//# sourceMappingURL=getCustomPivotFromTabId.js.map